export const GET_SHOPS_REQUEST = "GET_SHOPS_REQUEST";
export const GET_SHOPS_SUCCESS = "GET_SHOPS_SUCCESS";
export const GET_SHOPS_FAILURE = "GET_SHOPS_FAILURE";

export const getShopsRequest = ({ accountId, staffId }) => ({
  type: GET_SHOPS_REQUEST,
  payload: { accountId, staffId },
});

export const getShopsSuccess = (shops) => ({
  type: GET_SHOPS_SUCCESS,
  payload: shops,
});

export const getShopsFailure = (error) => {
  return {
    type: GET_SHOPS_FAILURE,
    payload: error,
  };
};
